let customerInfo = { cardCode: "", cardName: "" }
export let PKGPackagingCustomerChooser = { customerInfo }
